<template>
  <router-link
    :to="{ name: 'lianzheng_detail', query: { id: item.id } }"
    class="zhengwu-item"
    target="_blank"
  >
    <div class="title" :title="item.title">{{ item.title }}</div>
    <div class="subtitle">
      <span class="time">{{ item.addtime | dayjs("year-date") }}</span>
      <span class="source" v-if="item.resource">{{ item.resource }}</span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
